/**
 * Checklist Item
 * Renders a read-only checkbox with label
 */

import { Checkbox, makeStyles, tokens } from '@fluentui/react-components'
import type { InsightContentItem } from '../../../../domain'

const useStyles = makeStyles({
  root: {
    display: 'flex',
    alignItems: 'flex-start',
  },
  checkbox: {
    pointerEvents: 'none',
  },
  checked: {
    color: tokens.colorNeutralForeground2,
  },
  unchecked: {
    color: tokens.colorNeutralForeground1,
  },
})

export interface ChecklistItemProps {
  item: InsightContentItem
}

export function ChecklistItem({ item }: ChecklistItemProps) {
  const styles = useStyles()
  const isChecked = item.checked ?? false

  return (
    <div className={styles.root}>
      <Checkbox
        checked={isChecked}
        label={item.content}
        className={styles.checkbox}
        labelPosition="after"
      />
    </div>
  )
}
